<template>
  <div class="panel panel-default">
    <div class="panel-heading p-10" role="tab" :id="`${id}-heading`">
      <h5 class="panel-title">
        <a
          role="button"
          :href="`#${id}`"
          aria-expanded="false"
          :aria-controls="id"
          @click="isOpen = !isOpen"
        >
          <slot name="title"></slot>
        </a>
        <popover :content="tooltip" v-if="tooltip"></popover>
        <a
          class="pull-right"
          role="button"
          data-parent="#accordion"
          :href="`#${id}`"
          aria-expanded="false"
          aria-controls="collapse"
          @click="isOpen = !isOpen"
        >
          <span :class="isOpen ? 'fas fa-chevron-down' : 'fas fa-chevron-left'"></span>
        </a>
      </h5>
    </div>
    <div
      :id="id"
      :class="['panel-collapse', isOpen ? 'in' : 'collapse']"
      role="tabpanel"
      :aria-labelledby="`${id}-heading`"
    >
      <div class="panel-body p-10">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    name: 'BaseAccordionPanel',

    props: {
      tooltip: {
        type: String,
      },
      id: {
        type: String,
      },
      openByDefault: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      this.isOpen = this.openByDefault;
    },
    data() {
      return {
        isOpen: false,
      };
    },
  };
</script>
